import React, { useState, useContext } from 'react'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'
import { usePromiseTracker } from 'react-promise-tracker'
import ItemsCarousel from 'react-items-carousel'
import AppContext from '../../../context/appContext'

import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
} from '../Shared/SharedStyledComponents'
import { DietTile, DietTileTextRow } from './ChooseDietScreenStyles'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import NavigationBar from '../../NavigationBar/NavigationBar'
import MobileTopNavigationBar from '../../MobileTopNavigationBar/MobileTopNavigationBarContainer'
import Loader from '../../Loader/Loader'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'
import { setDiet } from '../../../Api/dietApi/userInfo'

import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import Navigation from '../../Challenges/components/Navigation/Navigation'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import {
  AlbumCard,
  AlbumName,
  LeftArrowButton,
  RightArrowButton,
} from '../../MainScreen/styles/MainScreenStyles'

import { DietContainer, CarouselContainer } from '../style/DietStyle'

import FitmatkaImage from '../../../assets/REDESIGN_Assets/Diet/fitmatka-image.webp'

interface ChooseDietScreenProps {
  diets: any
  goToCalculator: Function
  isDemoAccount: boolean
  challengeMode: boolean
}

const ChooseDietScreen: React.FC<ChooseDietScreenProps> = ({
  diets,
  goToCalculator,
  isDemoAccount,
  challengeMode
}) => {
  let history = useHistory()
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()
  const [activeItemIndex, setActiveItemIndex] = useState(0)


  let userHasDiet = false

  const goToDiet = (dietType: string) => {
    history.push({
      pathname: `/dieta/${dietType}`,
      state: { dietType: dietType },
    })
  }

  const goBackToMainpage = () => {
    history.push('/trening')
  }
  const chevronWidth = 40

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'center'}
      align={'center'}
      // className="standard mainpage"
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        } mainpage`}
    >
      {challengeMode ? <Navigation /> : <NavigationBar isPlayerView={false} backButtonAction={goBackToMainpage} />}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={() => history.push('/dieta')}
        />
      )}
      <DietContainer>
        {/* <GenericIcon
          zIndex={'0'}
          src={FitmatkaImage}
          height={isMobile ? '100vh' : '70vh'}
          width={isMobile ? '100vw' : '29vw'}
          top={isMobile ? '-30%' : '-5%'}
          left={isMobile ? '5%' : 'unset'}
          position="absolute"
        ></GenericIcon> */}
        <GenericRow
          width={isMobile ? '100%' : 'calc(100% - 80px)'}
          top={isMobile ? '30%' : '50%'}
          justify="flex-start"
        >
          <GenericTextSpan
            width={'100%'}
            display={'block'}
            fSize={isMobile ? '2.4rem' : '1.6rem'}
            color={appContext.appState.theme == 'light' ? '#342152' : 'white'}
          >
            Wybierz rodzaj diety
          </GenericTextSpan>
        </GenericRow>
        <CarouselContainer>
          <div style={{ padding: `0 ${chevronWidth}px` }}>
            {/* <LeftCarouselFadeIn /> */}
            <ItemsCarousel
              requestToChangeActive={setActiveItemIndex}
              activeItemIndex={activeItemIndex}
              numberOfCards={window.innerWidth > 1500 ? 4 : !isMobile ? 3 : 1}
              gutter={20}
              leftChevron={
                <LeftArrowButton
                  className={`${appContext.appState.theme == 'light' ? 'light' : ''
                    }`}
                />
              }
              rightChevron={
                <RightArrowButton
                  className={`${appContext.appState.theme == 'light' ? 'light' : ''
                    }`}
                />
              }
              outsideChevron
              chevronWidth={chevronWidth}
              infiniteLoop={true}
            >
              {diets &&
                diets.map((diet: any) => (
                  <AlbumCard
                    className={`active diet`}
                    src={diet.thumbnail_url}
                    onClick={
                      !userHasDiet
                        ? () => goToCalculator(diet.id)
                        : () => goToDiet(diet.title)
                    }
                  >
                    <GenericTextSpan
                      margin={'5% 0'}
                      tAlign={'left'}
                      fSize={'1.5rem'}
                      fWeight={'bold'}
                    >
                      {diet.title}
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={'1rem'}
                      tAlign={'left'}
                      opacity={'0.7'}
                    >
                      {diet.subtitle}
                    </GenericTextSpan>
                  </AlbumCard>
                ))}
              {/* <div style={{ height: 200, background: '#EEE' }}>First card</div>
          <div style={{ height: 200, background: '#EEE' }}>Second card</div>
          <div style={{ height: 200, background: '#EEE' }}>Third card</div>
          <div style={{ height: 200, background: '#EEE' }}>Fourth card</div> */}
            </ItemsCarousel>
          </div>
        </CarouselContainer>
        {!isMobile && (
          <GenericLogo
            top={'55%'}
            theme={appContext.appState.theme == 'light' ? 'light' : null}
          />
        )}
      </DietContainer>
    </GenericBackgroundLayer>
    // <ScreenContainer flexDirection={'column'}>
    //   <TopColorBar relative>
    //     <BackButton place={'Diety'} specialLocation={'/dieta'} />
    //   </TopColorBar>
    //   {/* <MobileTopNavigationBar /> */}
    //   <NavigationBar />
    //   <MainHeader>Diety</MainHeader>
    //   <MainSubHeader>Wybierz rodzaj diety</MainSubHeader>
    //   <MainContentContainer
    //     padding={isMobile ? '2vh 1vw' : '5vh 3vw'}
    //     justify={'center'}
    //     marginTop={isMobile ? '1vh' : '5vh'}
    //   >
    //     {diets &&
    //       diets.map((dietTile: any) => (
    //         <DietTile
    //           onClick={
    //             !userHasDiet
    //               ? () => goToCalculator(dietTile.id)
    //               : goToDiet(dietTile.title)
    //           }
    //           image={dietTile.thumbnail_url}
    //         >
    //           <DietTileTextRow
    //             color={'#ffffff'}
    //             fSize={14}
    //             lHeight={1.93}
    //             letterSpacing={'0.7px'}
    //           >
    //             {dietTile.subtitle}
    //           </DietTileTextRow>
    //           <DietTileTextRow color={'#ffffff'} fSize={33} lHeight={1.15}>
    //             {dietTile.title}
    //           </DietTileTextRow>
    //         </DietTile>
    //       ))}
    //   </MainContentContainer>
    //   {isDemoAccount && <DemoModeAnnouncement />}
    //   {promiseInProgress && <Loader />}
    // </ScreenContainer>
  )
}

export default ChooseDietScreen
